<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="展示位置" prop="location">
              <a-select
                default-value="lucy"
                style="width: 200px"
                @change="handleChange"
                v-model="formInline.location"
              >
                <a-select-option value="3">通用</a-select-option>
                <a-select-option value="1">门店首页</a-select-option>
                <a-select-option value="2"> 门店详情页 </a-select-option>
                <a-select-option value="4"> 兑换商城页 </a-select-option>
                <a-select-option value="5"> 福利群二维码 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" html-type="submit"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <a-button
          type="primary"
          :style="{ margin: '0 0 24px 0' }"
          v-on:click="topage('/home/carouselManagement/newCarousel')"
        >
          新增
        </a-button>
        <a-button @click="dels" type="danger" :style="{ margin: '0 0 24px 0' }">
          批量删除
        </a-button>
        <carouselManagementContent
          ref="aaa"
          :formInline="formInline"
        ></carouselManagementContent>
      </div>
    </a-layout-content>
    <a-button type="primary" style="margin: 16px">
      <a-icon type="left" />返回</a-button
    >
  </div>
</template>

<script>
import { delCarouseList } from "@/api/storeApi.js";
import carouselManagementContent from "./carouselManagementContent.vue";
export default {
  components: {
    carouselManagementContent,
  },
  data() {
    return {
      formInline: {
        location: "",
        limit: 10,
        page: 1,
      },
    };
  },
  mounted() {
    // this.$refs.ids.$on("getIds", this.getIds);
    this.dels();
  },
  methods: {
    handleSubmit(e) {
      console.log(this.formInline);
      this.$refs.aaa.query();
    },
    dels() {
      let ids = this.$store.state.ids;
      delCarouseList(ids).then((res) => {
        console.log(res);
        this.$refs.aaa.getCarouseListData();
      });
    },
    resetForm() {
      this.$refs.aaa.getCarouseListData();
      this.formInline = {};
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/carouselManagement/carouselManagementHome.vue